import React from "react";
import {
  FaArrowRight,
  FaClock,
  FaLeaf,
} from "react-icons/fa";

/* ─────────────────────────────────────
   PARAM PREMIUM DESIGN SYSTEM
───────────────────────────────────── */

const T = {
  orange: "#F28C28",
  orange2: "#F6A04D",

  cream: "#FAF8F5",
  cream2: "#F7F2EC",

  brown: "#24160F",
  brown2: "#5E4638",

  text: "#1F140F",
  text2: "#6B574A",
  text3: "#9B8575",

  white: "#FFFFFF",
};

/* ─────────────────────────────────────
   BLOG DATA
───────────────────────────────────── */

const blogData = [
  {
    image: "/assets/knowyourself/blogs/blog1/Picture1.png",
    title:
      "Why You’re Doing “All the Right Things” — But Still Don’t Feel Alright",
    excerpt:
      "Inspired by Yoga, Ayurveda, and Positive Psychology, discover the holistic framework for deeper wellbeing.",
    tag: "Holistic Wellness",
    readTime: "6 Min Read",
    link:
      "/wellness-blogs/four-pillar-approach-of-holistic-well-being",
  },

  {
    image: "/assets/knowyourself/blogs/blog2/b2p1.jpg",
    title:
      "“Bro, What’s Your Protein Intake?” — And Other Myths About Food",
    excerpt:
      "Food shapes not just your body — but your emotions, focus, sleep, and inner energy.",
    tag: "Nutrition",
    readTime: "5 Min Read",
    link: "/wellness-blogs/food-beyond-fuel",
  },

  {
    image: "/assets/knowyourself/blogs/blog3/b3p1.png",
    title:
      "“Just 5 Minutes on Instagram” — And Other Lies We Tell Ourselves",
    excerpt:
      "We live in a world overflowing with stimulation yet struggling with attention and peace.",
    tag: "Mindfulness",
    readTime: "7 Min Read",
    link:
      "/wellness-blogs/science-of-scattered-minds",
  },

  {
    image: "/assets/knowyourself/blogs/blog4.png",
    title:
      "Never Do These 7 Mistakes After 30",
    excerpt:
      "The silent mistakes draining your energy, clarity, and peace after 30.",
    tag: "Lifestyle",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/never-do-these-mistakes-after-30",
  },

  {
    image: "/assets/knowyourself/blogs/blog5.png",
    title:
      "10 Micro Habits That Create Massive Shifts",
    excerpt:
      "Simple daily habits that quietly transform your focus, energy, and emotional wellbeing.",
    tag: "Habits",
    readTime: "4 Min Read",
    link:
      "/wellness-blogs/10-micro-habits-for-massive-shifts",
  },

  {
    image: "/assets/knowyourself/blogs/blog6.jpg",
    title:
      "🌤️ 11 Tiny Morning Habits That Reduce Stress Instantly",
    excerpt:
      "Tiny rituals that help you begin your day calmer, lighter, and mentally clearer.",
    tag: "Morning Routine",
    readTime: "4 Min Read",
    link:
      "/wellness-blogs/tiny-morning-habits",
  },

  {
    image: "/assets/knowyourself/blogs/blog7.jpg",
    title:
      "🌱 Are You Choosing Your Life — Or Just Settling For It?",
    excerpt:
      "Break free from comfort loops and start building the life you genuinely want.",
    tag: "Self Growth",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/choosing-or-settling",
  },

  {
    image: "/assets/knowyourself/blogs/blog8.png",
    title:
      "🧠 If You Don’t Program Your Mind — Someone Else Will",
    excerpt:
      "Learn how external noise silently shapes your thoughts, desires, and habits.",
    tag: "Mindset",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/how-to-control-your-mind",
  },

  {
    image: "/assets/knowyourself/blogs/blog9.jpg",
    title:
      "🌿 7 Things Our Grandparents Did Right",
    excerpt:
      "Rediscover timeless habits that once created healthier and calmer lifestyles.",
    tag: "Ancient Wisdom",
    readTime: "6 Min Read",
    link:
      "/wellness-blogs/things-our-grandparents-did-right",
  },

  {
    image: "/assets/knowyourself/blogs/blog10.png",
    title:
      "🌧 Why Your Life Isn’t Moving Forward",
    excerpt:
      "Understand the hidden emotional and mental patterns keeping you stuck.",
    tag: "Self Growth",
    readTime: "4 Min Read",
    link:
      "/wellness-blogs/why-life-feels-stuck",
  },

  {
    image: "/assets/knowyourself/blogs/blog11.png",
    title:
      "🧠 11 Simple Habits That Protect Your Mental Health Daily",
    excerpt:
      "Small daily practices that help you feel calmer and emotionally safer.",
    tag: "Mental Health",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/11-simple-habits-that-protect-your-mental-health-daily",
  },

  {
    image: "/assets/knowyourself/blogs/blog12.png",
    title:
      "☀️ 9 Morning Habits That Power Up Your Whole Day",
    excerpt:
      "Morning rituals that shape your energy, peace, and emotional clarity.",
    tag: "Morning Routine",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/9-morning-habits-that-power-up-your-whole-day",
  },

  {
    image: "/assets/knowyourself/blogs/blog13.png",
    title:
      "✨ 11 Things to Start Doing Before You Turn 30",
    excerpt:
      "Practices that help you build inner peace, awareness, and emotional maturity.",
    tag: "Life Lessons",
    readTime: "6 Min Read",
    link:
      "/wellness-blogs/11-things-to-start-doing-before-you-turn-30",
  },

  {
    image: "/assets/knowyourself/blogs/blog14.png",
    title:
      "🩺 9 Hidden Signs Your Body Needs Attention",
    excerpt:
      "Your body communicates through subtle signals long before burnout appears.",
    tag: "Body Awareness",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/9-hidden-signs-your-body-needs-attention",
  },

  {
    image: "/assets/knowyourself/blogs/blog15.png",
    title:
      "🌿 8 Everyday Triggers Destroying Your Gut",
    excerpt:
      "Stress, speed, and habits silently damage digestion more than you realize.",
    tag: "Gut Health",
    readTime: "6 Min Read",
    link:
      "/wellness-blogs/8-everyday-triggers-that-are-silently-destroying-your-gut",
  },

  {
    image: "/assets/knowyourself/blogs/blog16.png",
    title:
      "🧠 7 Things Emotionally Intelligent People Don’t Do",
    excerpt:
      "Habits emotionally aware people avoid to stay calm, grounded, and balanced.",
    tag: "Emotional Intelligence",
    readTime: "4 Min Read",
    link:
      "/wellness-blogs/7-things-emotionally-intelligent-people-dont-do",
  },

  {
    image: "/assets/knowyourself/blogs/blog17.png",
    title:
      "🧘 Master This Habit — And People Will Stop Triggering You",
    excerpt:
      "The powerful pause that helps you protect your peace and emotional balance.",
    tag: "Emotional Wellness",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/master-this-habit-and-people-will-stop-triggering-you",
  },

  {
    image: "/assets/knowyourself/blogs/blog18.png",
    title:
      "🪞 10 Signs You’re Acting as Your Own Worst Enemy",
    excerpt:
      "Awareness of self-sabotaging patterns is the beginning of personal transformation.",
    tag: "Self Awareness",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/10-signs-youre-acting-as-your-own-worst-enemy",
  },

  {
    image: "/assets/knowyourself/blogs/blog19.png",
    title:
      "🌸 9 Health Priorities Every Woman Over 25",
    excerpt:
      "Protect your hormones, energy, and emotional balance before burnout begins.",
    tag: "Women's Wellness",
    readTime: "6 Min Read",
    link:
      "/wellness-blogs/9-health-priorities-every-woman-over-25",
  },

  {
    image: "/assets/knowyourself/blogs/blog20.png",
    title:
      "💫 9 Habits Women Over 30 Should Ditch",
    excerpt:
      "The everyday habits silently disrupting hormonal balance and emotional wellbeing.",
    tag: "Hormonal Health",
    readTime: "5 Min Read",
    link:
      "/wellness-blogs/9-habits-women-over-30-should-ditch-for-hormonal-health",
  },
];

/* ─────────────────────────────────────
   BLOG CARD
───────────────────────────────────── */

const BlogCard = ({ item }) => {
  return (
    <div
      className="
        group
        relative
        overflow-hidden
        rounded-[28px]
        h-[420px]
        bg-black
        shadow-[0_20px_60px_rgba(20,10,0,.10)]
        transition-all
        duration-500
        hover:-translate-y-2
      "
    >
      {/* IMAGE */}
      <img
        src={item.image}
        alt={item.title}
        className="
          w-full
          h-full
          object-cover
          brightness-[.84]
          saturate-[.9]
          transition-transform
          duration-700
          group-hover:scale-105
        "
      />

      {/* OVERLAY */}
      <div
        className="
          absolute
          inset-0
          bg-gradient-to-t
          from-black/90
          via-black/35
          to-transparent
        "
      />

      {/* TAG */}
      <div
        className="
          absolute
          top-5
          left-5
          flex
          items-center
          gap-2
          px-3
          py-2
          rounded-full
          bg-white/10
          backdrop-blur-xl
          border
          border-white/10
          text-white
          text-[11px]
          tracking-wider
        "
      >
        <FaLeaf size={9} />
        {item.tag}
      </div>

      {/* CONTENT */}
      <div className="absolute inset-x-0 bottom-0 p-5">
        <div
          className="
            rounded-[24px]
            bg-white/10
            backdrop-blur-2xl
            border
            border-white/10
            p-5
          "
        >
          {/* META */}
          <div className="flex items-center gap-2 text-white/70 text-xs mb-3">
            <FaClock size={10} />
            {item.readTime}
          </div>

          {/* TITLE */}
          <h2
            className="
              text-[22px]
              leading-[1.08]
              text-[#FFF8F2]
              font-medium
              mb-3
              tracking-[-0.03em]
              line-clamp-2
            "
            >
            {item.title}
          </h2>

          {/* EXCERPT */}
          <p
            className="
              text-white/70
              leading-7
              text-[14px]
              mb-5
              line-clamp-3
            "
          >
            {item.excerpt}
          </p>

          {/* BUTTON */}
          <a
            href={item.link}
            className="
              inline-flex
              items-center
              gap-2
              h-11
              px-5
              rounded-full
              text-white
              font-semibold
              text-sm
              shadow-[0_14px_34px_rgba(242,140,40,.24)]
              transition-all
              duration-300
              hover:scale-[1.02]
            "
            style={{
              background:
                "linear-gradient(135deg,#F28C28,#F6A04D)",
            }}
          >
            Read Article
            <FaArrowRight size={10} />
          </a>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────
   MAIN SECTION
───────────────────────────────────── */

const BlogSection = () => {
  return (
    <section
      className="
        relative
        overflow-hidden
        py-24
        px-5
      "
      style={{
        background: `
          radial-gradient(circle at top left,
          rgba(242,140,40,.10),
          transparent 24%),
          ${T.cream}
        `,
      }}
    >
      {/* GLOW */}
      <div
        className="
          absolute
          w-[500px]
          h-[500px]
          rounded-full
          blur-[120px]
          top-[-180px]
          right-[-120px]
        "
        style={{
          background:
            "rgba(242,140,40,.08)",
        }}
      />

      <div className="max-w-[1400px] mx-auto relative z-10">
        {/* HEADER */}
        <div className="text-center mb-16">
          <div
            className="
              inline-flex
              items-center
              px-4
              py-2
              rounded-full
              text-xs
              font-semibold
              tracking-[.08em]
              mb-5
            "
            style={{
              background: "#FFF1E4",
              color: T.orange,
            }}
          >
            PARAM INSIGHTS
          </div>

          <h1
            className="
              text-[clamp(36px,5vw,68px)]
              leading-[1.02]
              tracking-[-0.05em]
              mb-5
            "
            style={{
              color: T.brown,
              fontWeight: 400,
            }}
          >
Pearls of wisdom for
            <br />
 healthy, successful, and joyful living.           </h1>

          <p
            className="
              max-w-[720px]
              mx-auto
              text-[16px]
              leading-8
            "
            style={{
              color: T.text2,
            }}
          >
            Explore mindful articles on emotional
            wellbeing, Ayurveda, inner growth,
            mental clarity, conscious habits,
            and holistic living.
          </p>
        </div>

        {/* GRID */}
        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-3
            xl:grid-cols-4
            gap-6
          "
        >
          {blogData.map((item, index) => (
            <BlogCard
              key={index}
              item={item}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;